import { t } from '@lingui/core/macro';
/**
 * Labels for the search fields that have no `DocumentMetadataProperty` behind them.
 *
 * Every other selectable field in Insights is a metadata property, and its label comes
 * from `documentMetadataProperties` — see `getFieldLabel`. Only add a field here
 * when the search API exposes it but the DMS does not define it as a property.
 */
export function searchFieldLabels() {
    return {
        categoryId: t({
            message: 'Template categories',
            comment: 'Insights: Search field label: categoryId',
        }),
        createdAt: t({
            message: 'Document creation date',
            comment: 'Insights: Search field label: createdAt',
        }),
        createdByUserId: t({
            message: 'Contract creator',
            comment: 'Insights: Search field label: createdByUserId',
        }),
        entityId: t({
            message: 'Contract ID',
            comment: 'Insights: Search field label: entityId',
        }),
        entityType: t({
            message: 'Type of document',
            comment: 'Insights: Search field label: entityType',
        }),
        marketCode: t({
            message: 'Market',
            comment: 'Insights: Search field label: marketCode',
        }),
        metadataDocumentDateSigned: t({
            message: 'Date signed',
            comment: 'Insights: Search field label: metadataDocumentDateSigned',
        }),
        metadataDocumentEsigningStatus: t({
            message: 'eSigning status',
            comment: 'Insights: Search field label: metadataDocumentEsigningStatus',
        }),
        metadataDocumentIsSharedExternally: t({
            message: 'Shared externally',
            comment: 'Insights: Search field label: metadataDocumentIsSharedExternally',
        }),
        metadataDocumentStatus: t({
            message: 'Document status',
            comment: 'Insights: Search field label: metadataDocumentStatus',
        }),
        metadataDocumentType: t({
            message: 'Document type',
            comment: 'Insights: Search field label: metadataDocumentType',
        }),
        updatedAt: t({
            message: 'Document updated at',
            comment: 'Insights: Search field label: updatedAt',
        }),
    };
}
